import css from '@styled-system/css';

import { TokenizedCssArg } from './types';

export const tokenizedCss = ({ scale }: TokenizedCssArg) => {
  return (props) => {
    const cssTokens = props.theme.components[scale]?.css;
    return cssTokens ? css(cssTokens)(props) : {};
  };
};
